import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const GoogleCallback = () => {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the credential from URL hash (Google returns it as #credential=...)
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const credential = params.get('credential');

        if (!credential) {
          setError('No authentication credential received');
          return;
        }

        // Use the credential to log in
        const result = await googleLogin(credential);

        if (result.success) {
          // Redirect to home page
          navigate('/');
        } else {
          setError(result.message || 'Google login failed');
        }
      } catch (err) {
        console.error('Google callback error:', err);
        setError(err.message || 'An error occurred during Google login');
      }
    };

    handleCallback();
  }, [googleLogin, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brown-50 p-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
          <div className="text-red-600 text-4xl mb-4 text-center">✗</div>
          <h2 className="text-xl font-bold text-center text-brown-800 mb-4">
            Sign In Failed
          </h2>
          <p className="text-brown-600 text-center mb-4">{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg transition-colors duration-300"
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-brown-50 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
        <h2 className="text-xl font-bold text-brown-800 mb-2">
          Completing Sign In...
        </h2>
        <p className="text-brown-600">
          Please wait while we verify your Google account.
        </p>
      </div>
    </div>
  );
};

export default GoogleCallback;
